import Vue from 'vue';
import Axios from 'axios';
import VueAxios from 'vue-axios';
import { VueAuthenticate } from 'vue-authenticate';
import forEach from 'lodash/forEach';
import { Model } from 'vue-api-query';
import store from '@/store';

Axios.defaults.baseURL = process.env.API_LOCATION;
Axios.defaults.headers.common.Accept = 'application/json';
Axios.interceptors.response.use(
  (response) => {
    if (response.data.message) {
      Vue.toasted.success(response.data.message);
    }
    store.dispatch('wait/end', 'global loading', { root: true });
    return response;
  },
  (error) => {
    if (error.response.status === 422) {
      forEach(error.response.data.errors, (err) => {
        Vue.toasted.error(err[0]);
      });
    } else {
      Vue.toasted.error(error.response.data.message);
    }
    if (error.response.status === 401) {
      store.dispatch('auth/logout', true);
    }
    store.dispatch('wait/end', 'global loading', { root: true });
    return Promise.reject(error);
  },
);

// Bind Axios to Vue.
// Vue.$http = Axios;
Model.$http = Axios;
// Object.defineProperty(Vue.prototype, '$http', {
//   get() {
//     return Axios;
//   },
// });

Vue.use(VueAxios, Axios);

// Vue.use(VueAuthenticate, {
//   baseUrl: process.env.API_LOCATION, // Your API domainapi
// });

Vue.$auth = new VueAuthenticate(Vue.prototype.$http, {
  baseUrl: process.env.API_LOCATION,
  loginUrl: '/auth/login/admin',
});



// WEBPACK FOOTER //
// ./src/plugins/axios.js